"use client";

// Feature-row widths — deterministic so the skeleton doesn't jitter on re-render.
const FEATURE_WIDTHS = ["w-3/4", "w-2/3", "w-4/5", "w-1/2", "w-3/5", "w-11/12"];

/**
 * Loading placeholder for a single plan card. Mirrors the real PlanCard shell
 * (header → price → CTA → feature list) so it has genuine height and reads as a
 * card when the grid stacks to one column on mobile — the old empty boxes
 * collapsed to zero height there.
 */
function PlanCardSkeleton() {
  return (
    <div className="flex flex-col overflow-hidden rounded-lg border border-border bg-surface-primary dark:border-white/10 dark:bg-white/1">
      {/* Header: icon + name, seats note, description, price */}
      <div className="flex flex-col gap-2 border-b border-border p-4 dark:border-white/10">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1.5">
            <div className="size-6 rounded bg-contrast/6 animate-pulse" />
            <div className="h-4 w-16 rounded bg-contrast/6 animate-pulse" />
          </div>
          <div className="h-3 w-16 rounded bg-contrast/5 animate-pulse" />
        </div>
        <div className="h-3 w-3/4 rounded bg-contrast/5 animate-pulse" />
        <div className="mt-1 h-7 w-24 rounded-md bg-contrast/6 animate-pulse" />
        <div className="h-3 w-2/3 rounded bg-contrast/5 animate-pulse" />
      </div>

      {/* CTA button */}
      <div className="border-b border-border p-4 dark:border-white/10">
        <div className="h-8 w-full rounded-md bg-contrast/6 animate-pulse" />
      </div>

      {/* Feature list */}
      <div className="flex flex-col gap-3 p-4">
        {FEATURE_WIDTHS.map((w, i) => (
          <div key={i} className="flex items-center gap-1.5">
            <div className="size-3.5 shrink-0 rounded-full bg-contrast/6 animate-pulse" />
            <div className={`h-3 rounded bg-contrast/5 animate-pulse ${w}`} />
          </div>
        ))}
      </div>
    </div>
  );
}

/** Loading state for the "Choose plan" onboarding step. */
export function ChoosePlanPending() {
  return (
    <div className="flex flex-col gap-3 flex-1 min-h-0">
      {/* Billing toggle + Enterprise link */}
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between shrink-0">
        <div className="h-9 w-full sm:w-72 rounded-lg bg-contrast/4 animate-pulse" />
        <div className="h-4 w-40 shrink-0 rounded bg-contrast/4 animate-pulse" />
      </div>

      {/* Plan cards — stacked on mobile, 3-up on desktop (mirrors the real grid) */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 lg:flex-1 lg:min-h-0">
        {[0, 1, 2].map((i) => (
          <PlanCardSkeleton key={i} />
        ))}
      </div>
    </div>
  );
}
